var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.5,
    height: 19.704,
    viewBox: "0 0 17.5 19.704",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(-30.25 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(34.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M125.8,0a4.8,4.8,0,1,0,4.8,4.8A4.8,4.8,0,0,0,125.8,0Z",
    transform: "translate(-121)",
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(31 10.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M44.972,302.069A6.843,6.843,0,0,0,40.067,300h-2.13a6.843,6.843,0,0,0-4.905,2.069A7,7,0,0,0,31,307a.533.533,0,0,0,.533.533H46.467A.533.533,0,0,0,47,307,7,7,0,0,0,44.972,302.069Z",
    transform: "translate(-31 -300)",
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 1.5
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.f3ff7153.svg";
export { ForwardRef as ReactComponent };